const bankData = [
  { code: '0307', name: '平安银行', singlelimit: '5万', dateLimit: '5万' },
  { code: '0103', name: '中国农业银行', singlelimit: '0.1万', dateLimit: '0.5万' },
  { code: '0100', name: '中国邮政储蓄银行', singlelimit: '0.5万', dateLimit: '0.5万' },
  { code: '0308', name: '招商银行', singlelimit: '0.5万', dateLimit: '0.5万', monthLimit: '5万/月' },
  { code: '0102', name: '中国工商银行', singlelimit: '5万', dateLimit: '5万' },
  { code: '0105', name: '中国建设银行', singlelimit: '5万', dateLimit: '5万' },
  { code: '0301', name: '交通银行', singlelimit: '2万', dateLimit: '2万', monthLimit: '5万/月' },
  { code: '0302', name: '中信银行', singlelimit: '0.5万', dateLimit: '0.5万' },
  { code: '0303', name: '中国光大银行', singlelimit: '2万', dateLimit: '2万' },
  //{ code: '0305', name: '中国民生银行' },
  { code: '0306', name: '广东发展银行', singlelimit: '1万', dateLimit: '1万' },
  { code: '0104', name: '中国银行', singlelimit: '1万', dateLimit: '1万' },
  { code: '0309', name: '兴业银行', singlelimit: '0.5万', dateLimit: '0.5万' },
  { code: '0310', name: '上海浦东发展银行', singlelimit: '2万', dateLimit: '2万' },
  { code: '04012900', name: '上海银行', singlelimit: '1万', dateLimit: '1万' },
  { code: '04031000', name: '北京银行', singlelimit: '不限', dateLimit: '不限' },
  { code: '0304', name: '华夏银行', singlelimit: '0.5万', dateLimit: '0.5万' },
];

export default bankData;
